<template>
  <div class="history">
    <el-drawer
      size="50%"
      title="详情"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
    >
      <basic-container>
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="1">
            <avue-form :option="option" v-model="form"></avue-form>
            <div class="pics">
              <div class="sub-title">图片</div>

              <el-col :span="8">
                <div class="label">开始码表</div>
                <img
                  :src="form.beginClockUrl"
                  class="pic"
                  alt=""
                  v-if="form.beginClockUrl"
                />
              </el-col>
              <el-col :span="8">
                <div class="label">结束码表</div>
                <img
                  :src="form.endClockUrl"
                  alt=""
                  class="pic"
                  v-if="form.endClockUrl"
                />
              </el-col>
              <el-col :span="8">
                <div class="label">拍照凭证</div>
                <img
                  :src="form.pictureUrl"
                  class="pic"
                  alt=""
                  v-if="form.pictureUrl"
                />
              </el-col>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审核流程" name="2">
            <div
              class="info"
              style="width:80%;margin-left: 5px"
              v-if="flowList && flowList.length > 0"
            >
              <!-- color="#409eff" -->
              <div class="approvalFlow">
                <el-timeline>
                  <el-timeline-item
                    :timestamp="item.companyPositionName"
                    placement="top"
                    :class="item.currentAuditFlag == 1 ? 'myActive' : ''"
                    :color="item.currentAuditFlag == 1 ? '#409eff' : ''"
                    v-for="(item, index) in flowList"
                    :key="index"
                  >
                    <i
                      :class="
                        item.isShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                      @click="showMore(item)"
                      v-if="item.approveStatus == 1"
                      style="
                        cursor: pointer;
                        position: absolute;
                        right: -20px;
                        top: 0px;
                        font-size: 18px;
                      "
                    ></i>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 10px;
                      "
                    >
                      <h4>{{ item.approveUsername }}</h4>
                      <span>{{ item.approveDatetime }}</span>
                    </div>
                    <div class="textarea">
                      <div class="text">{{ item.approveRemark }}</div>
                      <div class="pics" v-if="item.approvePictureUrl">
                        <el-image
                          v-for="(item2, idx) in item.approvePictureUrl.split(
                            ','
                          )"
                          :key="idx"
                          style="width: 60px; height: 60px; margin-right: 2px"
                          :preview-src-list="item.approvePictureUrl.split(',')"
                          :src="item2"
                        >
                        </el-image>
                      </div>
                    </div>
                    <!-- <el-input
                      type="textarea"
                      v-if="item.approveRemark"
                      v-model="item.approveRemark"
                      :autosize="{ minRows: 3, maxRows: 8 }"
                      disabled
                    ></el-input> -->
                    <div v-if="item.isShow">{{ item.positionStaffName }}</div>
                    <!-- <div v-if="item.approvePictureUrl">
                      <el-image
                        v-for="(item2, idx) in item.approvePictureUrl.split(
                          ','
                        )"
                        :key="idx"
                        style="
                          width: 70px;
                          height: 70px;
                          margin-right: 8px;
                          margin-top: 8px;
                        "
                        :preview-src-list="item.approvePictureUrl.split(',')"
                        :src="item2"
                      >
                      </el-image>
                    </div> -->
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
            <el-empty v-else></el-empty>
          </el-tab-pane>
        </el-tabs>
      </basic-container>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getFlowNode } from "@/api/chain/ledgerDig2";
// import poPerson from "@/views/chain/waybillProcessSettings/poPerson"
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      flowList: [],
      activeName: "1",
      form: {},
      option: {
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 0,
        labelPosition: "left",
        detail: true,
        column: [
            {
            label: "创建时间",
            prop: "createDatetime",
            span: 8,
          },
          {
            label: "台班编号",
            prop: "ledgerNo",
            span: 8,
          },
          {
            label: "台班状态",
            prop: "auditStatus",
            type: "select", // 下拉选择
            dicData: [
              {
                label: "提交",
                value: "0",
              },
              {
                label: "审批中",
                value: "1",
              },
              {
                label: "已审批",
                value: "2",
              },
              {
                label: "已驳回",
                value: "3",
              },
              {
                label: "已删除",
                value: "7",
              },
            ],
            span: 8,
          },

          {
            label: "项目名称",
            prop: "projectName",
            span: 8,
          },
           {
            label: "审批状态",
            prop: "auditStatusName",
            span: 8,
          },
          {
            label: "挖机签单班次",
            prop: "inShiftTypeName",
            span: 8,
          },
          {
            label: "作业类型",
            prop: "ledgerType",
            span: 8,
          },
          {
            label: "挖机类型",
            prop: "inType",
            span: 8,
          },
          {
            label: "挖机车主",
            prop: "ownerName",
            span: 8,
          },
          
          {
            label: "挖机车主手机",
            prop: "ownerMobile",
            span: 8,
          },
          {
            label: "挖机型号",
            prop: "machineCode",
            span: 8,
          },
          {
            label: "挖机员",
            prop: "staffName",
            span: 8,
          },
          {
            label: "完成量",
            prop: "scheduleWork",
            span: 8,
          },
          {
            label: "地块",
            prop: "landName",
            span: 8,
          },

          // {
          //   label: "审核状态",
          //   prop: "approveStatus",
          //   type: "select", // 下拉选择
          //   dicData: [
          //     {
          //       label: "待审核",
          //       value: "1",
          //     },
          //     {
          //       label: "已审核",
          //       value: "2",
          //     },
          //     {
          //       label: "已驳回",
          //       value: "3",
          //     },
          //   ],
          // },

          {
            label: "单位",
            prop: "unitWork",
            span: 8,
          },

          {
            label: "作业地点",
            prop: "address",
            span: 8,
          },
          {
            label: "开始时间",
            prop: "startDatetime",
            span: 8,
          },
          {
            label: "结束时间",
            prop: "endDatetime",
            span: 8,
          },
          {
            label: "时长",
            prop: "workTime",
            span: 8,
          },
          {
            label: "转换时长",
            prop: "workHour",
            span: 8,
          },
          {
            label: "是否签证",
            prop: "isVisa",
            type: "select", // 下拉选择
            dicData: [
              {
                label: "是",
                value: "1",
              },
              {
                label: "否",
                value: "0",
              },
            ],
            span: 8,
          },
          {
            label: "开始码表",
            prop: "beginClock",
            span: 8,
          },
          {
            label: "结束码表",
            prop: "endClock",
            span: 8,
          },
          {
            label: "加油升数",
            prop: "refuelingLitres",
            span: 8,
          },
          {
            label: "费用(元)",
            prop: "cost",
            span: 8,
          },
          {
            label: "是否餐补",
            prop: "isSubsidizedMeals",
            span: 8,
          },
          {
            label: "加班时长(小时)",
            prop: "overtimeHours",
            span: 8,
          },
          {
            label: "备注",
            prop: "ledgerRemark",
            span: 8,
          },
          {
            label: "PC备注",
            prop: "pcLedgerRemark",
            span: 8,
          },
          {
            label: "台班价",
            prop: "preparePrice",
            span: 8,
          },
          {
            label: "是否删除",
            prop: "isDel",
            type: "select", // 下拉选择
            dicData: [
              {
                label: "是",
                value: "1",
              },
              {
                label: "否",
                value: "0",
              },
            ],
            span: 8,
          },

          // {
          //   label: "照片凭证",
          //   prop: "pictureUrl",
          //   type: "upload",
          //   listType: "picture-img",
          //   dataType: "string",
          //   span: 8,
          // },
          // {
          //   label: "开始码表拍照",
          //   prop: "beginClockUrl",
          //   type: "upload",
          //   listType: "picture-img",
          //   dataType: "string",
          //   span: 8,
          // },
          // {
          //   label: "结束码表拍照",
          //   prop: "endClockUrl",
          //   type: "upload",
          //   listType: "picture-img",
          //   width: 50,
          //   height: 50,
          //   dataType: "string",
          //   span: 8,
          // },

          // {
          //   label: "创建日期",
          //   prop: "searchDate",
          //   valueFormat: 'yyyy-MM-dd',
          // },
          // {
          //   label: "班次日期",
          //   prop: "inShiftTime",
          //   valueFormat: 'yyyy-MM-dd',
          // },

          
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.form = Object.assign({}, this.info);
    this.getData();
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    cancelModal() {
      this.$emit("update:visible", false);
    },
    getData() {
      getFlowNode(this.info.ledgerType == "签证" ? 3 : 2, this.info.id).then(
        (res) => {
          this.flowList = res.data.data;
        }
      );
    },
    showMore(item) {
      console.log(item);
      this.$set(item, "isShow", !item.isShow);
      // item.isShow = !item.isShow
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 10px;
}
/deep/ .myActive .el-timeline-item__tail {
  border-left-color: #409eff;
}
/deep/.is-always-shadow {
  box-shadow: none !important;
  border: none;
}
/deep/.el-collapse-item__wrap .avue-form__group--flex {
  background: #fff !important;
}
/deep/.el-form-item__label {
  width: auto !important;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  padding-right: 10px !important;
}
/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px!important;
}
/deep/.el-input__inner {
  padding-left: 0 !important;
  font-weight: 400;
  font-size: 14px;
  color: #939399 !important;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #939399 !important;
}
/deep/.avue-form {
  padding: 0 !important;
}
/deep/.el-tabs__nav-wrap::after {
  height: 0 !important;
}
/deep/.el-col-8 {
  padding: 0 !important;
}
.pics {
  .sub-title {
    font-weight: 500;
    font-size: 14px;
    color: #313133;
    margin-bottom: 16px;
  }
}
/deep/.pic {
  width: 160px;
  height: 80px;
  border-radius: 4px;
}
.label {
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  padding-bottom: 12px;
}
/deep/.el-tabs__active-bar {
  height: 0 !important;
}
/deep/.el-drawer__header {
  border-bottom: 1px solid #ededf0;
  padding-bottom: 11px;
}
/deep/.el-timeline-item__node--normal {
  width: 8px;
  height: 8px;
  // padding-bottom: 8px;
  border: 2px solid #35b1ff;
  background-color: #fff;
}
/deep/.el-timeline-item__tail {
  border-color: #35b1ff;
  height: 80%;
  top: 28px;
}
/deep/.el-timeline-item {
  padding: 8px 0;
}
/deep/.el-timeline-item__timestamp {
  font-weight: 400;
  font-size: 16px;
  color: #313133;
}
/deep/.el-timeline-item__content {
  h4 {
    font-weight: 400;
    font-size: 14px;
    color: #626266;
  }
  span {
    font-weight: 400;
    font-size: 14px;
    color: #626266;
  }
}
.textarea{
  padding: 6px 10px;
  background: #F5F7FA;
border-radius: 2px;
border: 1px solid #EDEDF0;
.text{
  height: 88px;
}
}
/deep/.el-collapse-item__wrap .avue-form__group--flex{
  padding-top: 0 !important;
}
</style>
